import React, { useState, useEffect } from "react";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";

const HeroSlider = () => {
	const [images, setImages] = useState([]);
	const [index, setIndex] = useState(0);

	useEffect(() => {
		fetch("/api/sliderimage/")
			.then((res) => res.json())
			.then((data) => {
				if (Array.isArray(data)) setImages(data.filter((item) => item.image));
			})
			.catch((error) => console.log(error));
	}, []);

	// Move to the next picture every 5 seconds
	useEffect(() => {
		if (images.length < 2) return undefined;
		const timer = setInterval(
			() => setIndex((current) => (current + 1) % images.length),
			5000
		);
		return () => clearInterval(timer);
	}, [images.length]);

	const go = (step) =>
		setIndex((current) => (current + step + images.length) % images.length);

	return (
		<div className='hs' aria-roledescription='carousel' aria-label='Photos'>
			{images.map((item, i) => (
				<div
					key={item.id}
					className={i === index ? "hs-slide is-on" : "hs-slide"}
					style={{ "--bg": `url("${item.image}")` }}
				>
					<img
						src={item.image}
						alt=''
						loading={i === 0 ? "eager" : "lazy"}
					/>
				</div>
			))}
			{images.length > 1 && (
				<>
					<button
						type='button'
						className='hs-btn prev'
						onClick={() => go(-1)}
						aria-label='Previous photo'
					>
						<FaChevronLeft />
					</button>
					<button
						type='button'
						className='hs-btn next'
						onClick={() => go(1)}
						aria-label='Next photo'
					>
						<FaChevronRight />
					</button>
					<div className='hs-dots'>
						{images.map((item, i) => (
							<button
								type='button'
								key={item.id}
								className={i === index ? "is-on" : ""}
								onClick={() => setIndex(i)}
								aria-label={`Photo ${i + 1}`}
							/>
						))}
					</div>
				</>
			)}
		</div>
	);
};

export default HeroSlider;
